export const GET_PICKLIST_REPORT_REQUEST = "GET_PICKLIST_REPORT_REQUEST";
export const GET_PICKLIST_REPORT_SUCCESS = "GET_PICKLIST_REPORT_SUCCESS";
export const GET_PICKLIST_REPORT_FAILURE = "GET_PICKLIST_REPORT_FAILURE";

export const GET_PICKLIST_DOWNLOAD_REQUEST = "GET_PICKLIST_DOWNLOAD_REQUEST";
export const GET_PICKLIST_DOWNLOAD_SUCCESS = "GET_PICKLIST_DOWNLOAD_SUCCESS";
export const GET_PICKLIST_DOWNLOAD_FAILURE = "GET_PICKLIST_DOWNLOAD_FAILURE";
 